import _ from 'lodash'

export function getShortcut(row, jobType, jobId) {
  let shortcutId = null
  let jobLink = null
  let relatedId = null

  if (!_.isNull(row.estimate_id)) {
    shortcutId = row.estimate_id
    jobLink = `/jobView/${jobId}/${jobType}/site-estimates`
  } else if (!_.isNull(row.proposal_id)) {
    shortcutId = row.proposal_id
    jobLink = ''
  } else if (!_.isNull(row.contract_id)) {
    shortcutId = row.contract_id
    jobLink = ''
  } else if (!_.isNull(row.change_order_id)) {
    shortcutId = row.change_order_id
    relatedId = row.change_order_number
    jobLink = `/jobView/${jobId}/${jobType}/change-orders`
  } else if (!_.isNull(row.drawing_id)) {
    shortcutId = row.drawing_id
    jobLink = `/jobView/${jobId}/${jobType}/drawings`
  } else if (!_.isNull(row.payment_request_id)) {
    shortcutId = row.payment_request_id
    jobLink = `/jobView/${jobId}/${jobType}/payment-requests/modal/${row.payment_request_id}`
  } else if (!_.isNull(row.aia_id)) {
    shortcutId = row.aia_id
    jobLink = `/jobView/${jobId}/${jobType}/aias/modal/${row.aia_id}`
  } else if (!_.isNull(row.invoice_id)) {
    shortcutId = row.invoice_id
    jobLink = `/jobView/${jobId}/${jobType}/invoices/modal/${row.invoice_id}`
  } else if (!_.isNull(row.material_request_id)) {
    shortcutId = row.material_request_id
    jobLink = `/jobView/${jobId}/${jobType}/material-requests/modal/${row.material_request_id}`
  } else if (!_.isNull(row.schedule_id)) {
    shortcutId = row.schedule_id
    jobLink = ''
  } else if (!_.isNull(row.schedule_drawing_id)) {
    shortcutId = row.schedule_drawing_id
    jobLink = `/jobView/${jobId}/${jobType}/schedule-drawings`
  } else if (!_.isNull(row.schedule_manufacturing_id)) {
    shortcutId = row.schedule_manufacturing_id
    jobLink = `/jobView/${jobId}/${jobType}/manufacturing`
  } else if (!_.isNull(row.schedule_application_id)) {
    shortcutId = row.schedule_application_id
    jobLink = ''
  } else if (!_.isNull(row.schedule_site_work_id)) {
    shortcutId = row.schedule_site_work_id
    jobLink = `/jobView/${jobId}/${jobType}/sitework`
  } else if (!_.isNull(row.stop_call_id)) {
    shortcutId = row.stop_call_id
    jobLink = `/jobView/${jobId}/${jobType}/stop-calls`
  } else if (!_.isNull(row.rfi_id)) {
    shortcutId = row.rfi_id
    jobLink = `/jobView/${jobId}/${jobType}/site-rfi`
  } else if (!_.isNull(row.transmittal_id)) {
    shortcutId = row.transmittal_id
    jobLink = `/jobView/${jobId}/${jobType}/transmittals`
  } else if (!_.isNull(row.employee_id)) {
    shortcutId = row.employee_id
    jobLink = ''
  } else if (!_.isNull(row.purchase_order_id)) {
    shortcutId = row.purchase_order_id
    jobLink = `/jobView/${jobId}/${jobType}/vendors/purchase-order/modal/${row.purchase_order_id}`
  } else if (!_.isNull(row.violation_id)) {
    shortcutId = row.violation_id
    jobLink = `/jobView/${jobId}/${jobType}/violations`
  } else if (!_.isNull(row.vehicle_id)) {
    shortcutId = row.vehicle_id
    jobLink = ''
  } else if (!_.isNull(row.attachment_id)) {
    shortcutId = row.attachment_id
    jobLink = `/jobView/${jobId}/${jobType}/attachments`
  }

  return { shortcutId: shortcutId, jobLink: jobLink, relatedId: relatedId }
}



// WEBPACK FOOTER //
// ./src/util/jobFollowUps.js